// extracted by mini-css-extract-plugin
export var footerBlock = "FooterBlock-module--footerBlock--934e5";